import { render, staticRenderFns } from "./todoedit.vue?vue&type=template&id=33e99158&"
import script from "./todoedit.vue?vue&type=script&lang=js&"
export * from "./todoedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports